// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"j3-z","sponsoredTooltipWrapper":"k3-z","sponsoredTooltip":"l3-z","newCard":"m3-z"};